/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'log-out': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M31 14.822a1 1 0 010 2H12.29a1 1 0 010-2H31zm-4.813-1.986a1 1 0 011.338-1.486l4.144 3.729a1.003 1.003 0 010 1.487l-4.144 3.729a1.001 1.001 0 01-1.648-.536 1 1 0 01.31-.951l3.318-2.986-3.318-2.986zm-6.288 9.24a1 1 0 012 0V31a1 1 0 01-1 1H1a1 1 0 01-1-1V1a1 1 0 011-1h19.9a1 1 0 011 1v7.405a1 1 0 01-2 0V2H2v28h17.9v-7.924h-.001z"/>'
  }
})
